import React from "react";
import { Link } from 'react-router-dom';

export const Footer = () => {

    return (
        <div className="container">
            <div className="footer-bottom">
                <div className="row align-items-center">
                    <div className="col-12 col-md-4 col-lg-4 col-xl-5">
                        <div className="copy-txt">
                            <span>© {new Date().getFullYear()} infocliq all rights reserved</span>
                        </div>
                    </div>
                    <div className="col-12 col-md-8 col-lg-8 col-xl-7">
                        <ul className="footer-bottom-menu">
                            <li><Link to={'#'}>Privacy Policy</Link></li>
                            {/*  < li > <Link to={'#'}>Terms of Use</Link></li> */}
                            {/* <li><Link to={'#'}>Support Policy</Link></li> */}
                            <li><Link to={'#'}>Terms of Service</Link></li>
                        </ul>
                    </div>
                </div>
            </div>
        </div >
    )
}